module.exports = __webpack_public_path__ + "images/card-placeholder2.png";